import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  IQBOOST_V2_FEATURE_FLAG,
  IQBoostViewStore,
  isGlobalServersInEffect,
  PiiAnonymizationService,
} from '@maximizer/ai/data-access';
import { FeatureService } from '@maximizer/core/shared/data-access';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_POPUP } from '@progress/kendo-angular-popup';

const SECURITY_KEY = 'iqboost.chat.security';

@Component({
  selector: 'ai-iqboost-security-status',
  templateUrl: './iqboost-security-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KENDO_POPUP, TranslatePipe, UI_KENDO],
})
export class IqboostSecurityStatusComponent {
  private readonly store = inject(IQBoostViewStore);
  private readonly piiAnonymization = inject(PiiAnonymizationService);
  private readonly feature = inject(FeatureService);

  protected readonly isOpen = signal(false);

  protected readonly anonymized = computed(() => this.piiAnonymization.anonymized());
  protected readonly useGlobalServers = computed(() => {
    const group = this.store.dataProcessingFeatureGroup();
    return isGlobalServersInEffect(
      group.admin.dataProcessingFeatures,
      group.user.dataProcessingFeatures.useGlobalServers,
      this.feature.isFeatureOn(IQBOOST_V2_FEATURE_FLAG, false),
    );
  });
  protected readonly useWebData = computed(() => {
    const group = this.store.dataProcessingFeatureGroup();
    return (
      group.user.dataProcessingFeatures.useWebData &&
      group.admin.dataProcessingFeatures.useWebData
    );
  });

  protected readonly statusKey = computed(
    () => `${SECURITY_KEY}.${this.anonymized() ? 'anonymized' : 'notAnonymized'}`,
  );
  protected readonly anonymizerKey = computed(
    () => `${SECURITY_KEY}.${this.anonymized() ? 'anonymizerOn' : 'anonymizerOff'}`,
  );
  protected readonly residencyKey = computed(
    () => `${SECURITY_KEY}.${this.useGlobalServers() ? 'residencyGlobal' : 'residencyCanada'}`,
  );
  protected readonly sourceKey = computed(
    () => `${SECURITY_KEY}.${this.useWebData() ? 'sourceOnline' : 'sourceMaximizer'}`,
  );

  protected toggle(): void {
    this.isOpen.update((open) => !open);
  }

  protected close(): void {
    this.isOpen.set(false);
  }
}
